import axios from 'axios';
import {useQuery} from '@tanstack/react-query';

import {Keys} from 'client/api/_keys';
import {Routes} from 'client/api/_routes';

const contactUs = async () => axios.get(Routes.CONTACT_US);

export const useContactUs = () =>
  useQuery({
    queryKey: [Keys.CONTACT_US_QRY],
    queryFn: contactUs,
  });
